import routes from "."

export default [...routes]
